<template>
  <div :class="bem">
    <div :class="`${bem}__base`">
      <div :class="`${bem}__avatar`">
        <img :src="profileInfo.avatar" alt="avatar" />
      </div>
      <div :class="`${bem}__info`">
        <div class="name">{{ profileInfo.name }}</div>
        <div class="gender">
          {{ profileInfo.gender }}{{ profileInfo.age > -1 ? `·${profileInfo.age}岁` : '·年龄未知' }}
        </div>
      </div>
      <div :class="`${bem}__relation`">
        {{ profileInfo.relation }}
      </div>
    </div>
    <div :class="`${bem}__idNo`">
      <div class="id-type">{{ profileInfo.certType }}</div>
      <div class="id-no">{{ profileInfo.certNo }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
const bem = 'fda-profile-card';
interface profileCardProps {
  profileInfo: {
    avatar: string;
    name: string;
    relation?: string;
    gender?: string;
    age: number;
    certNo: string;
    certType: string;
  };
}

const props = withDefaults(defineProps<profileCardProps>(), {});
const { profileInfo } = toRefs(props);
</script>

<style scoped lang="less">
.fda-profile-card {
  overflow: hidden;
  position: relative;
  margin: 0 32px 24px;
  padding: 24px;
  border: 2px solid rgba(255, 255, 255, 0%);
  border-radius: 8px;
  background: linear-gradient(180deg, #9cc9ff 0.3%, #cce3ff 100%);
  box-shadow: 0 10px 16px 0 rgba(0, 0, 0, 10%);

  &__base {
    display: flex;
    margin-bottom: 30px;
  }

  &__avatar {
    img {
      width: 80px;
      height: 80px;
    }

    margin-right: 24px;
    border-radius: 50%;
  }

  &__info {
    margin-right: 24px;
    height: 80px;

    .name {
      height: 45px;
      font-weight: 500;
      font-size: 32px;
      color: rgba(0, 0, 0, 90%);
    }

    .gender {
      margin-top: 5px;
      height: 34px;
      font-size: 24px;
      color: #16181a;
    }
  }

  &__relation {
    border-radius: 4px;
    width: 82px;
    height: 40px;
    background-color: rgba(255, 255, 255, 40%);
    line-height: 40px;
    text-align: center;
    font-size: 21px;
    color: #4e5761;
  }

  &__idNo {
    div {
      margin: 10px 0;
      padding-left: 24px;
      font-weight: 400;
      font-size: 28px;
      color: #16181a;
      letter-spacing: 1px;
    }

    .id-type {
      margin-bottom: 8px;
      border-left: 4px solid #0d7cff;
    }

    .id-no {
      padding-left: 28px;
      font-weight: 500;
    }
  }
}
</style>
